import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import General from './components/General.vue';
import Location from './components/Location.vue';
import { can, useRouting } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const $routing = useRouting();

const organizationId = computed(() => Number($routing.route.params.id));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SHOW]))
      ? (_openBlock(), _createBlock(General, {
          key: 0,
          "organization-id": organizationId.value
        }, null, 8, ["organization-id"]))
      : _createCommentVNode("", true),
    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_LOCATIONS_INDEX]))
      ? (_openBlock(), _createBlock(Location, {
          key: 1,
          "organization-id": organizationId.value
        }, null, 8, ["organization-id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})